<template>
  <div class="card modal-card" v-if="copieContact">
    <header class="bandeau-modal card-header">
    </header>
    <div class="modal-card-body">
    <div class="card-content">
      <error-msg-component :messages="messagesErreur"
        :error="error"
        :title="'editionClient.problemOccurred'"
        :withEmplyFields="true"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :titreMessageErreurEcran="titreMessageErreurEcran"
        @close="error = $event"/>
      <section class="has-text-centered">
        <p class="modal-title has-text-centered">
          {{titrePopUp}}
        </p>
      </section>
      <br>
      <div class="tab is-marginless mgb-20px">
        <ul>
          <li :class="{'is-active': activeTab === 'contacts'}"
            @click="activeTab = 'contacts'">
            {{ $t('editionContact.tabs.contact') }}
          </li>
          <li :class="{'is-active': activeTab === 'portail'}" v-if="displayPortail"
            @click="activeTab = 'portail'">
            {{ $t('editionContact.tabs.portail') }}
          </li>
          <li :class="{'is-active': activeTab === 'contactsTiers'}"
            v-if="modulePortailClientActive && idTiers && !isFromBailleur"
            @click="activeTab = 'contactsTiers'">
            {{ $t('editionContact.tabs.contactsTiers') }}
          </li>
        </ul>
      </div>
      <footer :class="{'scroll': error}"
        v-if="activeTab === 'contacts'">
        <div class="columns is-multiline is-paddingless is-variable mgt-10px">
          <parametre-autocomplete
            :label="$t('editionContact.civility')"
            v-model="copieContact.civiliteId"
            :target="constantes.PARAMETRES_KEYS.civilite"
            expanded
            class="column is-4 is-marginless pdv-0"
          />
          <b-field :label="$t('editionContact.name')" :type="typeNom"
                   class="column is-4 is-marginless pdv-0 obligatoire">
            <b-input v-model="copieContact.nom"></b-input>
          </b-field>

          <b-field :label="$t('editionContact.firstname')"
                   class="column is-4 is-marginless pdv-0">
            <b-input v-model="copieContact.prenom"></b-input>
          </b-field>
          <app-input-email :label="$t('editionContact.email')"
            v-model="copieContact.email"
            class="column is-4 is-marginless pdv-0"
            :class="{'obligatoire' : copieContact.accesPortail}"/>
          <b-field :label="$t('editionContact.phone')"
                   class="column is-4 is-marginless pdv-0">
            <b-input v-model="copieContact.telephone"></b-input>
          </b-field>
          <b-field :label="$t('editionContact.cellPhone')"
                   class="column is-4 is-marginless pdv-0">
            <b-input v-model="copieContact.portable"></b-input>
          </b-field>
          <b-field :label="$t('editionContact.service')"
                   class="column is-6 is-marginless pdv-0">
            <b-input v-model="copieContact.service"></b-input>
          </b-field>
          <fonction-contact-autocomplete
            v-model="copieContact.fonction"
            :label="$t('editionContact.office')"
            class="column is-6 is-marginless pdv-0">
          </fonction-contact-autocomplete>
          <b-field
            :label="$t('editionContact.typeContact')"
            class="column is-12 is-marginless pdv-0">
            <qd-taginput
              v-model="typesContactSelected"
              :data="filteredTagsTypeContact"
              @typing="getfilteredTypeContact"
              @input="getTypeContactTag"
              open-on-focus
              icon="magnify"
              field="libelle"
              type="is-primary"
              expanded
              autocomplete>
              <template slot="empty">
                <div>
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
              <template slot-scope="props">
                {{ props.option.libelle + ' - '
              + getTypeContactType(props.option.typeContactType) }}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <qd-checkbox v-model="copieContact.newsletter">
          <span> {{ $t('editionContact.newsLetter') }}</span>
        </qd-checkbox>
        <qd-checkbox v-model="copieContact.adresseContactDifferente"
          @input="selectionAdresseClient()">
          <span> {{ getHaveAdresse }}</span>
        </qd-checkbox>
        <div v-if="copieContact.adresseContactDifferente">
          <b-field :label="$t('editionContact.postalAddress')">
          </b-field>
          <app-adresse  :adresse="copieContact.adresse"
                        :tableName="TIERS"/>
        </div>
      </footer>
      <footer v-if="activeTab === 'portail'">
        <div class="columns is-multiline is-paddingless mgt-10px">
          <div class="column is-4">
            <qd-switch v-model="copieContact.accesPortail">
              {{ $t('editionContact.accesPortail') }}
            </qd-switch>
            <p v-if="copieContact.accesPortail"
              class="has-text-danger">
              {{ $t('editionContact.messages.warningMessageAccesPortail') }}
            </p>
          </div>
          <div class="column is-8 columns is-multiline pdt-0">
            <b-field :label="$t('editionContact.identifiant')"
              class="obligatoire column is-12 is-marginless pdt-0">
              <b-input
                :disabled="!copieContact.accesPortail"
                v-model="copieContact.utilisateur.identifiant"></b-input>
            </b-field>
            <app-input-email :label="$t('editionContact.email')"
              v-model="copieContact.email"
              class="column is-12 is-marginless pdv-0"
              :disabled="!copieContact.accesPortail"
              :class="{'obligatoire' : !isEditContact && copieContact.accesPortail}"/>
            <b-field :label="$t('editionContact.motDePasse')"
              class="column is-12 is-marginless"
              :class="{'obligatoire': !isEditContact && copieContact.accesPortail}">
              <b-input
                :disabled="!copieContact.accesPortail"
                type="password"
                v-model="copieContact.utilisateur.motPasse"
                password-reveal>
              </b-input>
            </b-field>
            <b-field :label="$t('editionContact.confirmerMotDePasse')"
              class="column is-12 is-marginless"
              :class="{'obligatoire': !isEditContact && copieContact.accesPortail}">
              <b-input
                :disabled="!copieContact.accesPortail"
                type="password"
                v-model="copieContact.utilisateur.motPasseConf"
                password-reveal>
              </b-input>
            </b-field>
          </div>
        </div>
      </footer>
      <footer v-if="activeTab === 'contactsTiers'">
        <contacts-tiers :contact="copieContactForLinkTiers"
          :isEdit="true"
          @updateContactsTiers="handleContactsTiersChange($event)">
        </contacts-tiers>
      </footer>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('editionClient.actions.revert')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="editionContact()">
            {{ !isEditContact
              ? $t('editionClient.actions.addContact2')
              : $t('editionClient.actions.editContact') }}
          </button>
        </div>
      </footer>
    </div>
    </div>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import Adresse from '@/components/general/adresse';
import InputEmail from '@/components/general/inputEmail';
import ContactsTiers from '@/components/tiers/contacts/m_ContactsTiers';
import gestionType from '@/services/general/gestionType';
import saveContact from '@/services/tiers/saveContact';
import validation from '@/services/tiers/validationContact';
import titreMessageErreur from '@/services/tiers/titreMessageErreur';
import adresseGenerer from '@/services/general/genererAdresse';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  TIERS_SOUS_TYPE_COLLECTIVITE,
  TIERS_TYPE_FOURNISSEUR,
  TIERS_TYPE_CLIENT,
  LISTE_SOUS_TYPE_BAILLEUR,
  TIERS_SOUS_TYPE_SERVICE,
} from '@/configuration/tiers/tiersConf';
import { TIERS } from '@/configuration/ville/villeConf';
import { LISTE_TYPE_CONTACT_TYPE } from '@/configuration/bodac/typeContact/typeContactConf';
import MixinParametreInterne from '@/mixins/parametreInterne';
import validationUtilisateur from '@/services/parametrage/validation/validationModificationUtilisateur';
import validationContactTiers from '@/services/contact/validationTiers';
import genererContactUtilisateur from '@/services/contact/genererContactUtilisateur';
import fonctionContactAutocomplete from '@/components/commun/contact/fonctionContactAutocomplete';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'ajouter-contact',
  props: ['contact', 'contacts', 'isEditContact', 'idTiers', 'tiers', 'isFromBailleur'],
  mixins: [MixinParametreInterne],
  components: {
    appAdresse: Adresse,
    appInputEmail: InputEmail,
    errorMsgComponent,
    ContactsTiers,
    fonctionContactAutocomplete,
    parametreAutocomplete,
  },
  data() {
    return {
      TIERS: TIERS,
      error: false,
      copieContact: null,
      messagesErreur: [],
      titreMessageErreurEcran: '',
      filteredTagsTypeContact: [],
      typesContactSelected: [],
      activeTab: 'contacts',
      messagesChampsVide: [],
      champsVide: [],
      contactsTiers: [],
      constantes: {
        PARAMETRES_KEYS: typesParametres.PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    typesContact() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.typeContact);
    },
    titrePopUp() {
      if (this.isEditContact === true) return this.$t('editionClient.actions.modifContact');
      return this.$t('editionClient.actions.addContact');
    },
    typeNom() {
      return gestionType(this.copieContact.nom, this.error);
    },
    getHaveAdresse() {
      if (this.tiers.type === TIERS_TYPE_CLIENT) return this.$i18n.t('editionContact.haveAddress');
      if (this.tiers.type === TIERS_TYPE_FOURNISSEUR && this.tiers.sousTypes.length === 1
        && this.tiers.sousTypes[0] === TIERS_SOUS_TYPE_COLLECTIVITE) {
        return this.$i18n.t('editionContact.haveAddressCollectivite');
      }
      if (this.tiers.type === TIERS_TYPE_FOURNISSEUR && this.tiers.sousTypes.length === 1
        && this.tiers.sousTypes[0] === TIERS_SOUS_TYPE_SERVICE) {
        return this.$i18n.t('editionContact.haveAddressService');
      }
      const bailleurSousTypes = LISTE_SOUS_TYPE_BAILLEUR.map(el => el.code);
      if (this.tiers.type === TIERS_TYPE_FOURNISSEUR
        && !this.tiers.sousTypes.some(el => bailleurSousTypes.includes(el))) {
        return this.$i18n.t('editionContact.haveAddressFournisseur');
      }
      if (this.$route.path.includes('ajoutFournisseur')
        || this.$route.path.includes('detailFournisseur')
        || this.$route.path.includes('editionFournisseur')) {
        return this.$i18n.t('editionFournisseur.contact.haveAddress');
      }
      return this.$i18n.t('addEditBailleur.contact.haveAddress');
    },
    modulePortailClientActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key);
    },
    displayPortail() {
      return (this.isFromBailleur && this.modulePortailBailleurActive)
        || (this.modulePortailClientActive && !this.isFromBailleur);
    },
    copieContactForLinkTiers() {
      const withTiersAndContactTiers = cloneDeep(this.copieContact);
      if (this.idTiers) withTiersAndContactTiers.tiersId = this.idTiers;
      if (this.contactsTiers) withTiersAndContactTiers.contactsTiers = this.contactsTiers ?? [];
      return withTiersAndContactTiers;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getTypeContactType(value) {
      const find = LISTE_TYPE_CONTACT_TYPE.find(el => el.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    getTypeContactTag() {
      this.filteredTagsTypeContact = this.typesContact.filter((el) => {
        return !this.typesContactSelected.find((elSelected) => elSelected.id === el.id);
      });
    },
    getfilteredTypeContact(text) {
      const filters = this.typesContact
        .filter((tc) => tc.libelle
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0);
      this.filteredTagsTypeContact = filters
        .filter(tc => !(this.typesContactSelected
          .map(type => type.id)
          .includes(tc.id)));
    },
    async editionContact() {
      const loadingComponent = this.$buefy.loading.open();
      this.copieContact.idTiers = this.idTiers;
      this.error = true;
      try {
        this.validationSauvegarde();
        if (this.error) {
          loadingComponent.close();
          return;
        }
        if (!this.copieContact.accesPortail) delete this.copieContact.utilisateur;
        this.copieContact.typesContactIds = this.typesContactSelected.map(tc => tc.id);
        if (this.contactsTiers) {
          this.copieContact.lienTiersId = this.contactsTiers.map(c => c.id);
          this.copieContact.contactsTiers = this.contactsTiers;
        }
        await saveContact(this.isEditContact, this.idTiers,
          this.copieContact, this.contacts, this.$i18n);
        loadingComponent.close();
        this.$emit('added', this.copieContact);
        this.$parent.close();
      } catch (e) {
        if ((e.response && e.response.data.error)) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messagesErreur = [];
          validationUtilisateur(e.response, '', this.champsVide, this.messagesErreur,
            this.messagesChampsVide);
          if (this.modulePortailClientActive) {
            validationContactTiers(e.response, this.messagesErreur, this.$i18n);
          }
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    validationSauvegarde() {
      this.messagesErreur = [];
      this.error = validation(this.copieContact, this.messagesErreur);
      if (this.error) {
        this.titreMessageErreurEcran = 'editionContact.' + titreMessageErreur(!this.isEditContact, this.messagesErreur);
      }
    },
    selectionAdresseClient() {
      if (!this.contact.adresseContactDifferente) {
        this.copieContact.adresse = adresseGenerer();
      }
    },
    handleContactsTiersChange(contactsTiers) {
      if (contactsTiers) {
        this.contactsTiers = contactsTiers;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.copieContact = cloneDeep(this.contact);
      this.contactsTiers = cloneDeep(this.contact)?.contactsTiers ?? [];
      if (!this.copieContact.accesPortail && !this.copieContact.utilisateur
          && (this.modulePortailBailleurActive || this.modulePortailClientActive)) {
        this.copieContact.utilisateur = genererContactUtilisateur();
      }
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.typeContact,
      ]);
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key,
      ]);
      this.typesContactSelected = this.typesContact
        .filter(tc => this.copieContact.typesContactIds
          && this.copieContact.typesContactIds.includes(tc.id));
      this.filteredTagsTypeContact = this.typesContact.filter((el) => {
        return !this.typesContactSelected.find((elSelected) => elSelected.id === el.id);
      });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>
  .scroll {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 58vh;
  }
</style>
